import { render, staticRenderFns } from "./CandidateKillerQuestions.vue?vue&type=template&id=850075aa&scoped=true"
import script from "./CandidateKillerQuestions.vue?vue&type=script&lang=js"
export * from "./CandidateKillerQuestions.vue?vue&type=script&lang=js"
import style0 from "./CandidateKillerQuestions.vue?vue&type=style&index=0&id=850075aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850075aa",
  null
  
)

export default component.exports